import {Box, Typography} from "@mui/material";
import React from "react";

interface BoxedInfoProps {
	label: string;
	content: React.ReactElement;
	labelAlignment?: "left" | "right" | "center";
	contentDirection?: "row" | "column";
	contentAlignment?: "flex-start" | "flex-end" | "center";
}

export function BoxedInfo(props: BoxedInfoProps) {
	const {
		label,
		content,
		labelAlignment = "center",
		contentDirection = "row",
		contentAlignment = "center",
	} = props;
	return (
		<>
			<Box
				sx={theme => ({
					background: theme.palette.primary.main,
					padding: "0.5rem 1rem",
				})}
			>
				<Typography
					align={labelAlignment}
					sx={{color: "#fff", fontWeight: "bold"}}
				>
					{label}
				</Typography>
			</Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: contentDirection,
					justifyContent: contentAlignment,
					border: "1px solid #000",
					padding: "0.5rem 1rem",
				}}
			>
				{content}
			</Box>
		</>
	);
}
